export const SET_PLAYER_BALANCE = "@playerBalance/setPlayerBalance"
export const ADD_PLAYER_POINTS = "@playerBalance/addPlayerPoints"
export const FETCH_PLAYER_BALANCE = "@playerBalance/fetchPlayerBalance"